import { useTheme } from "@hooks";
import { IconProps } from "./types";

export const Bank = ({ size = 14, style, fill: fillProp }: IconProps) => {
  const { theme } = useTheme();

  const fill = fillProp ?? theme.icon.default;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M2.5335 11.9818V6.33177H3.5335V11.9818H2.5335ZM6.56683 11.9818V6.33177H7.56683V11.9818H6.56683ZM0.333496 13.9818V12.9818H13.6668V13.9818H0.333496ZM10.4668 11.9818V6.33177H11.4668V11.9818H10.4668ZM0.333496 5.33177V4.44844L7.00016 0.648438L13.6668 4.44844V5.33177H0.333496ZM2.56683 4.33177H11.4335L7.00016 1.79844L2.56683 4.33177Z"
        fill={fill}
      />
    </svg>
  );
};
